import React from 'react';
import { useDispatch, useSelector } from 'react-redux';
import Presentation from '../../logic/redux/presentation';
import Modal from './modal';

const ModalPresenter = (): JSX.Element | null => {
  const dispatch = useDispatch();
  const modalContent = useSelector(Presentation.select.selectModalContent);
  const onClose = useSelector(Presentation.select.selectOnClose);
  console.log('ModalPresenter', onClose);

  const handleClose = (): void => {
    dispatch(Presentation.actions.setShowModal(undefined));
  };

  return (
    <Modal onClose={onClose !== undefined ? onClose : handleClose} open={!!modalContent}>
      {modalContent}
    </Modal>
  );
};

export default ModalPresenter;
